export const tripTemplates = [
  {
    id: 'weekend',
    name: 'Weekend Getaway',
    icon: '🗓️',
    description: '2-3 days for a quick escape',
    days: [
      { dayNumber: 1, title: 'Arrival & Exploration', activities: [] },
      { dayNumber: 2, title: 'Main Attractions', activities: [] },
      { dayNumber: 3, title: 'Departure', activities: [] },
    ],
  },
  {
    id: 'week',
    name: 'Week-long Adventure',
    icon: '✈️',
    description: '7 days for a comprehensive trip',
    days: Array.from({ length: 7 }, (_, i) => ({
      dayNumber: i + 1,
      title: `Day ${i + 1}`,
      activities: [],
    })),
  },
  {
    id: 'budget',
    name: 'Budget Trip',
    icon: '💰',
    description: 'Affordable travel with smart planning',
    days: [
      { dayNumber: 1, title: 'Arrival & Budget Accommodation', activities: [] },
      { dayNumber: 2, title: 'Free Attractions & Walking Tour', activities: [] },
      { dayNumber: 3, title: 'Local Food & Markets', activities: [] },
      { dayNumber: 4, title: 'Free Activities', activities: [] },
      { dayNumber: 5, title: 'Last Exploration', activities: [] },
      { dayNumber: 6, title: 'Final Day', activities: [] },
      { dayNumber: 7, title: 'Departure', activities: [] },
    ],
  },
  {
    id: 'luxury',
    name: 'Luxury Escape',
    icon: '⭐',
    description: 'High-end experiences and fine dining',
    days: Array.from({ length: 7 }, (_, i) => ({
      dayNumber: i + 1,
      title: `Day ${i + 1} - Premium Experience`,
      activities: [],
    })),
  },
  {
    id: 'food',
    name: 'Food & Wine Tour',
    icon: '🍷',
    description: 'Culinary adventures and local flavors',
    days: [
      { dayNumber: 1, title: 'Arrival & Welcome Dinner', activities: [] },
      { dayNumber: 2, title: 'Local Markets & Street Food', activities: [] },
      { dayNumber: 3, title: 'Cooking Class or Food Tour', activities: [] },
      { dayNumber: 4, title: 'Wine Region/ Brewery Visit', activities: [] },
      { dayNumber: 5, title: 'Fine Dining Experience', activities: [] },
      { dayNumber: 6, title: 'Food Souvenir Shopping', activities: [] },
      { dayNumber: 7, title: 'Departure', activities: [] },
    ],
  },
  {
    id: 'nature',
    name: 'Nature & Hiking',
    icon: '🏔️',
    description: 'Outdoor adventures and scenic trails',
    days: [
      { dayNumber: 1, title: 'Arrival & Base Camp', activities: [] },
      { dayNumber: 2, title: 'Hiking Trail Day 1', activities: [] },
      { dayNumber: 3, title: 'Hiking Trail Day 2', activities: [] },
      { dayNumber: 4, title: 'Scenic Views & Photography', activities: [] },
      { dayNumber: 5, title: 'Waterfall/Beach Day', activities: [] },
      { dayNumber: 6, title: 'Wildlife & Nature', activities: [] },
      { dayNumber: 7, title: 'Departure', activities: [] },
    ],
  },
];

export const getTemplate = (id) => tripTemplates.find(t => t.id === id);